module.exports = __webpack_public_path__ + "static/media/add tour.c0fc9988.svg";